


import React from 'react';

import Pmaterialproducts from './Pmaterialproducts';
import Mostimportantpropert from './Mostimportantpropert';
import Pvcpipefittable from './Pvcpipefittable';


const Pvcmaterialpro = () => {
    return (
        <div>
           <Pmaterialproducts />
            <Mostimportantpropert />
            <Pvcpipefittable />

        </div>
    );
};

export default Pvcmaterialpro;
